import AdminContainer from '../../Utility/AdminContainer';
import { PencilSimpleIcon } from '@phosphor-icons/react';
import useUsers from '../../../Hooks/useUsers';
import AdminBox from '../../Utility/AdminBox';
import AdminViewHeader from '../../Utility/AdminViewHeader';
import AdminViewContent from '../../Utility/AdminViewContent';
import { User } from '../../../Types';
import { PaginationListType } from '../../../Types/PaginationParams';
import PaginatedView from '../../Utility/PaginatedView';

function Users() {
    const { i18n, handleNavigate, windowWidth, getBreakpoint, userService } = useUsers();

    const GRID_COLS = 'grid-cols-[minmax(157px,300px),minmax(157px,300px),minmax(157px,1fr)]';

    return (
        <div className={`admin-container flex relative flex-col`}>
            <AdminContainer>
                <AdminBox classString="px-4">
                    <PaginatedView
                        listType={PaginationListType.Users}
                        itemsFunction={userService.getUsersByPage}
                        itemsPerPage={15}
                        renderItem={(user: User, index: number) => (
                            <AdminViewContent
                                key={user.identifier}
                                mobile={windowWidth < getBreakpoint('md')}
                                identifier={user.identifier}
                                gridCols={GRID_COLS}
                                cols={{
                                    optionalCols: [
                                        {
                                            content: user.givenName + ' ' + user.familyName,
                                        },
                                        {
                                            content: user.userName,
                                        },
                                    ],
                                    button: {
                                        buttons: [
                                            {
                                                variant: 'primaryRound',
                                                onClick: () => handleNavigate(user.identifier),
                                                icon: <PencilSimpleIcon />,
                                            },
                                        ],
                                    },
                                }}
                            />
                        )}
                    >
                        {({ list, filter }) => (
                            <>
                                {filter}
                                <div className="hidden md:block">
                                    <AdminViewHeader
                                        gridCols={GRID_COLS}
                                        cols={{
                                            cols: [
                                                {
                                                    text: i18n.translate({
                                                        id: 'adminHeader.mainCol',
                                                        sourceName: 'Main',
                                                    }),
                                                },
                                                {
                                                    text: i18n.translate({ id: 'users.userName', sourceName: 'Users' }),
                                                },
                                            ],
                                        }}
                                    />

                                    <hr className="border-layout-borderColor mt-5" />
                                </div>
                                {list}
                            </>
                        )}
                    </PaginatedView>
                </AdminBox>
            </AdminContainer>
        </div>
    );
}

export default Users;
